import React, { useState } from 'react';
import 'antd/dist/antd.css';
import { Layout, Breadcrumb, Card, Input, Button, Table, Space, message, Tag } from 'antd';
import MyMenu from '../../components/Menu';
import reqwest from 'reqwest';
import config from '../../config';
import moment from 'moment';
import { getToken } from '../../Utils/common';
import PatientProgress from '../../components/PatientProgress';

const { Content, Sider, Header } = Layout;

function HospitalizationClinicalHistories() {
  const [collapsed, setCollapsed] = useState(false);
  const [q, setQ] = useState('');
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [selectedPatientId, setSelectedPatientId] = useState(null);
  const [selectedPatientLabel, setSelectedPatientLabel] = useState('');

  const onSearch = () => {
    const query = (q || '').trim();
    if (!query) {
      setItems([]);
      setSelectedPatientId(null);
      setSelectedPatientLabel('');
      return;
    }
    setLoading(true);
    reqwest({
      url: `${config.api_url}/hospitalization/clinical-histories?q=${encodeURIComponent(query)}`,
      method: 'get',
      type: 'json',
      headers: { 'Authorization': `Token ${getToken()}` },
    }).then(resp => {
      const results = Array.isArray(resp) ? resp : (resp.results || []);
      setItems(results);
      if (results && results.length > 0) {
        // Tomar el primer paciente de los resultados para mostrar su historia completa
        const first = results[0];
        const pid = first.patient;
        const label = (`${first.patient_name || ''} ${first.patient_last_name || ''}`).trim() || `#${pid}`;
        setSelectedPatientId(pid);
        setSelectedPatientLabel(label);
      } else {
        setSelectedPatientId(null);
        setSelectedPatientLabel('');
      }
    }).catch(err => {
      const status = (err && err.status) || '';
      if (status === 401) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/login';
        return;
      }
      message.error('Error al buscar historias clínicas');
    }).always(() => setLoading(false));
  };

  // Mapeo fijo de colores por tipo (código)
  const TYPE_COLORS = {
    // Admisiones
    'APS': 'geekblue', 'APQ': 'geekblue', 'ACL': 'geekblue', 'AMU': 'geekblue', 'AAS': 'geekblue', 'ATO': 'geekblue', 'AKI': 'geekblue', 'ANU': 'geekblue',
    // Evoluciones
    'EPS': 'green', 'EPQ': 'green', 'ENF': 'green', 'EKI': 'green', 'ECM': 'green', 'EPM': 'green', 'HDD': 'green', 'TGR': 'green',
    // Evaluaciones/controles/mediciones
    'EXP': 'gold', 'EIE': 'gold', 'ECL': 'gold', 'ANA': 'gold', 'CSM': 'gold', 'CSV': 'gold', 'GLU': 'gold', 'PES': 'gold', 'PCA': 'gold',
    // Médicas / otras disciplinas
    'MCL': 'purple', 'MGR': 'purple',
    'NUT': 'magenta', 'ASO': 'cyan', 'EFM': 'volcano', 'PAE': 'orange',
  };

  const columns = [
    { title: 'Paciente', dataIndex: 'patient', key: 'patient', render: (_, r) => `${r.patient_name || ''} ${r.patient_last_name || ''}`.trim() || `#${r.patient}` },
    { title: 'Título', dataIndex: 'title', key: 'title' },
    { title: 'Tipo', dataIndex: 'type_choice', key: 'type_choice', render: (text, record) => {
        const color = TYPE_COLORS[record.type] || 'default';
        return <Tag color={color}>{text}</Tag>;
      }
    },
    { title: 'Creador', dataIndex: 'username', key: 'username' },
    { title: 'Creado', dataIndex: 'create_date', key: 'create_date', render: (v) => v ? moment(v).format('DD/MM/YYYY HH:mm') : '-' },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider collapsible collapsed={collapsed} onCollapse={(c) => setCollapsed(c)}>
        <div className="logo" />
        <MyMenu active={"8"} />
      </Sider>
      <Layout className="site-layout">
        <Header />
        <Content style={{ margin: '0 16px' }}>
          <Breadcrumb style={{ margin: '16px 0' }}>
            <Breadcrumb.Item>Historias clínicas de internación</Breadcrumb.Item>
          </Breadcrumb>
          <div className="site-layout-background" style={{ padding: 24 }}>
            <Card title="Historias Clínicas (Internación)">
              <Space style={{ marginBottom: 16 }}>
                <Input.Search
                  placeholder="Buscar por nombre o apellido del paciente"
                  allowClear
                  enterButton="Buscar"
                  onSearch={onSearch}
                  onChange={(e) => setQ(e.target.value)}
                  value={q}
                  disabled={!!selectedPatientId}
                />
                {selectedPatientId && (
                  <Button onClick={() => { setSelectedPatientId(null); setSelectedPatientLabel(''); setItems([]); setQ(''); }}>Nueva búsqueda</Button>
                )}
              </Space>

              {selectedPatientId ? (
                <div>
                  <div style={{ marginBottom: 12, fontWeight: 500 }}>Paciente: {selectedPatientLabel}</div>
                  <PatientProgress patient_id={selectedPatientId} />
                </div>
              ) : (
                <Table
                  rowKey={(r) => `${r.id}`}
                  columns={columns}
                  dataSource={items}
                  loading={loading}
                  pagination={{ pageSize: 10 }}
                />
              )}
            </Card>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default HospitalizationClinicalHistories;
